'use client'

import React from 'react'

import { cn } from '../../utils/cn'
import {
  AwardEmblemCommunity,
  AwardEmblemGymStudio,
  AwardEmblemRising,
} from './emblems'

export type AwardBadgeCategory =
  | 'bestGymStudio'
  | 'bestCommunity'
  | 'risingStar'

const categoryContents: Record<
  AwardBadgeCategory,
  { Emblem: React.FC<{ className?: string }>; label: string }
> = {
  bestGymStudio: {
    Emblem: AwardEmblemGymStudio,
    label: 'BEST GYM / BEST STUDIO',
  },
  bestCommunity: { Emblem: AwardEmblemCommunity, label: 'BEST COMMUNITY' },
  risingStar: { Emblem: AwardEmblemRising, label: 'RISING STAR' },
}

export interface AwardBadgeProps {
  /**
   * 受賞年度 (GYYM AWARDS {year})
   */
  year: number

  /**
   * 受賞部門 (部門ごとにエンブレムと表記が異なる)
   */
  category: AwardBadgeCategory

  /**
   * Class name
   */
  className?: string
}

/**
 * GYYM AWARDS 受賞バッジ (施設詳細画面用・部門別エンブレム付き)
 *
 * 施設カード用の1行マークは `AwardMark` を使用する
 */
export const AwardBadge = ({ year, category, className }: AwardBadgeProps) => {
  const { Emblem, label } = categoryContents[category]

  return (
    <span
      className={cn(
        'inline-flex w-fit shrink-0 items-center gap-2 rounded-full bg-[#0F1413] px-3 py-2',
        className,
      )}
    >
      <Emblem className="size-6 shrink-0" />
      <span className="flex flex-col gap-0.5 leading-none tracking-[1px] text-white">
        <span className="whitespace-nowrap text-[11px] font-bold">
          GYYM AWARDS {year}
        </span>
        <span className="whitespace-nowrap text-[10px]">{label} 受賞</span>
      </span>
    </span>
  )
}
